__turbopack_context__.v({
  "header": "quests-module__WIp48G__header",
  "root": "quests-module__WIp48G__root",
  "subtitle": "quests-module__WIp48G__subtitle",
  "title": "quests-module__WIp48G__title",
});
